<template>
  <div>
    <v-treeview
      :items="items"
      dense
      open-on-click
      rounded
      hoverable
      activatable
      :open="[...open_list]"
      :multiple-active="false"
      :expand-icon="'$subgroup'"
    >
      <template v-slot:label="data">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                v-if="data.item.path !== 'func_class'"
                @click="updateObject(data)"
                v-on="on"
                >
                <v-icon size="15">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>このオブジェクトを編集</span>
          </v-tooltip>
          {{data.item.no ? data.item.no + ' : ' : ''}}{{ data.item.name }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                v-if="data.item.path !== 'func_class' && data.item.path !== 'communication_design'"
                @click="createChild(data)"
                v-on="on"
                >
                <v-icon size="15">mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>このオブジェクトに子オブジェクトを追加</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                v-if="data.item.path !== 'func_class' && data.item.path !== 'system_specification'"
                @click="deleteAction(data)"
                v-on="on"
                >
                <v-icon
                  size="15"
                  color="red darken-4"
                >mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>このオブジェクトを削除</span>
          </v-tooltip>
        </div>
      </template>
    </v-treeview>
    <b-modal
      v-model="confirmDelete"
      hide-footer
    >
      <b-row align-h="center">
        <p>{{ deleteTarget.item.name }}を</p>
        <p>削除してよろしいですか。</p>
      </b-row>
      <b-row align-h="around">
        <button
          @click="deleteObject"
          class="btn btn-outline-danger"
        >はい</button>
        <button
          @click="confirmDelete = !confirmDelete"
          class="btn btn-outline-secondary"
        >いいえ</button>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'TreeView',
  props: ['version'],
  data () {
    return {
      isOpen: false,
      confirmDelete: false,
      deleteTarget: {
        item: {
          name
        }
      },
      items: [],
      response: [],
      open_list: []
    }
  },
  async mounted () {
    this.invokeObjects()
  },
  watch: {
    version: function () {
      this.invokeObjects()
    }
  },
  methods: {
    updateObject (args) {
      this.$router.push(`/${args.item.path}/${args.item.no}`)
    },
    createChild (args) {
      const childPath = this.childRelations[args.item.path]
      this.$router.push(`/${childPath}/?parent_id=${args.item.no}`)
    },
    deleteAction (args) {
      this.confirmDelete = true
      this.deleteTarget = args
    },
    async deleteObject () {
      const obj = this.deleteTarget.item.path
      const no = this.deleteTarget.item.no
      if (obj === 'system_function') {
        await this.deleteSystemFunction(no)
      } else if (obj === 'usecase') {
        await this.deleteUsecase(no)
      } else if (obj === 'communication_design') {
        await this.deleteCommunicationDesign(no)
      }
    },
    async deleteSystemFunction (no) {
      try {
        await API.graphql(graphqlOperation(`
          mutation deleteSystemFucnction {
            deleteSystemFunction(input:{
              no: ${no}
              version: "${this.version}"
            }) {
              no
              name
            }
          }
        `))
        this.makeToast('成功', '削除に成功しました', 'info')
        this.confirmDelete = false
        await this.invokeObjects()
      } catch (e) {
        this.makeToast('失敗', '削除に成功しました', 'info')
      }
    },
    async deleteUsecase (no) {
      try {
        await API.graphql(graphqlOperation(`
          mutation deleteUsecase {
            deleteUsecase(input:{
              no: ${no}
              version: "${this.version}"
            }) {
              no
              name
            }
          }
        `))
        this.makeToast('成功', '削除に成功しました', 'info')
        this.confirmDelete = false
        await this.invokeObjects()
      } catch (e) {
        this.makeToast('失敗', '削除に成功しました', 'info')
      }
    },
    async deleteCommunicationDesign (no) {
      try {
        await API.graphql(graphqlOperation(`
          mutation deleteCommunicationDesign {
            deleteCommunicationDesign(input:{
              no: ${no}
              version: "${this.version}"
            }) {
              no
              name
            }
          }
        `))
        this.makeToast('成功', '削除に成功しました', 'info')
        this.confirmDelete = false
        await this.invokeObjects()
      } catch (e) {
        this.makeToast('失敗', '削除に成功しました', 'info')
      }
    },
    async invokeObjects () {
      if (this.version === '') {
        return
      }
      const funcClasses = await API.graphql(graphqlOperation(`
        query listFuncClass {
          listFunctionClass{
            no
            function_class
          }
        }
      `))
      const response = await API.graphql(graphqlOperation(`
        query listSystemSpec{
          listSystemSpecifications(version: "${this.version}"){
            items {
              no
              name
              system_functions {
                items {
                  no
                  name
                  function_class
                  usecases {
                    items {
                      no
                      name
                      communication_designs {
                        items {
                          no
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `))
      this.$log.debug(response)
      this.items = response.data.listSystemSpecifications.items.map(function (spec) {
        const funcClasslist = funcClasses.data.listFunctionClass.map(function (funcClass) {
          const funcs = spec.system_functions.items.map(function (func) {
            const usecasesList = func.usecases.items.map(function (usecase) {
              const designs = usecase.communication_designs.items.map(function (design) {
                return {
                  id: 'design:' + design.no,
                  no: design.no,
                  name: design.name,
                  path: 'communication_design'
                }
              }).sort(function (a, b) {
                if (a.no > b.no) {
                  return 1
                } else {
                  return -1
                }
              })
              return {
                id: 'usecase:' + usecase.no,
                no: usecase.no,
                name: usecase.name,
                children: designs,
                path: 'usecase'
              }
            }).sort(function (a, b) {
              if (a.no > b.no) {
                return 1
              } else {
                return -1
              }
            })
            this.open_list.push([['func:' + func.no]])
            return {
              id: 'func:' + func.no,
              no: func.no,
              name: func.name,
              function_class: func.function_class,
              children: usecasesList,
              path: 'system_function'
            }
          }.bind(this)).sort(function (a, b) {
            if (a.no > b.no) {
              return 1
            } else {
              return -1
            }
          })
          const filtered = funcs.filter(function (filterFunc) {
            return filterFunc.function_class === funcClass.function_class
          })
          this.open_list.push(['func_class:' + funcClass.no])
          return {
            id: 'func_class:' + funcClass.no,
            path: 'func_class',
            name: funcClass.function_class,
            children: filtered
          }
        }.bind(this))
        this.open_list.push('spec:' + spec.no)
        return {
          id: 'spec:' + spec.no,
          no: spec.no,
          name: spec.name,
          children: funcClasslist,
          path: 'system_specification'
        }
      }.bind(this)).sort(function (a, b) {
        if (a.no > b.no) {
          return 1
        } else {
          return -1
        }
      })
    }
  }
}
</script>
